import { Button, Typography } from "@mui/material";
import React from "react";
const LogoBackDrop = ({ setShowLogoConfirm }) => {
  return (
    <div className="absolute inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="h-[240px] w-[540px] bg-white flex items-center justify-center text-black rounded-2xl relative">
        <Typography
          display="block"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="w-full h-full">
            <Button
              onClick={() => setShowLogoConfirm(false)}
              sx={{ position: "absolute", top: 16, right: 16 }}
            >
              <img src={require("../assets/close-icon.png")} />
            </Button>
          </div>
          <img
            src={require("../assets/verified.png")}
            className="w-20 h-20 text-[80px] text-[#26890D]"
          />
          <div className="p-4">Your logo file is successfully uploaded</div>
        </Typography>
      </div>
    </div>
  );
};

export default LogoBackDrop;